import React, { useContext, useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';
import styled, { css } from 'styled-components';
import UserContext from '../hooks/UserContext';
import Modal from '../components/Modal';
import Api from '../utils/Api';
import splashImg from '../images/wishlist.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons';


const modalStyles = css`
//padding: 40px;
display: flex;
flex-direction: column;
gap: 30px;
width: 100%;
& .email {
  font-weight: bold;
}
input {
  width: 75%;
}
`
const PwResetModal = styled(({ className, isOpen, onCancel, onConfirm }) => {
  const [pwResetEmail, setPwResetEmail] = useState('');
  return (
    <Modal isOpen={isOpen}>
      <title>
        Password Reset
      </title>
      <main>
        <div className={className}>
          <div>
            Please enter your email address that you use to login
          </div>
          <input placeholder='Login email' value={pwResetEmail} onChange={e => setPwResetEmail(e.target.value)} />
          <div>
            Click on "Send" to send a password reset link to your email address
          </div>
        </div>
      </main>
      <footer>
        <button className='danger' onClick={onCancel}>Cancel</button>
        <button className='primary' disabled={!pwResetEmail} onClick={() => onConfirm(pwResetEmail)}>Send</button>
      </footer>
    </Modal>)
})`${modalStyles}`;

const PwResetConfirmModal = styled(({ className, isOpen, email, onConfirm }) => {
  return (
    <Modal isOpen={isOpen}>
      <title>
        Password Reset Confirmation
      </title>
      <main>
        <div className={className}>
          <div>
            A Password Reset email has been sent to:
          </div>
          <div className='email'>
            {email}
          </div>
          <div>
            Please follow the instruction in the email your received
          </div>
        </div>
      </main>
      <footer>
        <button className='primary' onClick={onConfirm}>OK</button>
      </footer>
    </Modal>
  )
})`${modalStyles}`;

const pageCss = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
  .splash {
    img {
      width: 100px;
      padding-top: 5vh;
      padding-bottom: 10vh;
    }
  }
  .form {
    display:flex;
    flex-direction:column;
    gap: 20px;
    text-align: center;

    .auth {
      width: 40vw;
      min-width: 15em;
      text-align: center;
      display: flex;
      flex-direction: column;
      gap: 20px;
      
      > .password {
        display: flex;
        position: relative;
        align-items: center;
        > .eye {
          position: absolute;
          right: 15px;
        }
      }
      input {
        width: 100%;
        //margin: 20px auto;
      }
    }

    button {
      display: block;
      margin: 0 auto;
    }
  }
`
const Login = styled(({ className }) => {
  const { user, login, logout } = useContext(UserContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitOk, setSubmitOk] = useState(false);
  const [freshLogin, setFreshLogin] = useState(false);
  const [showResetPW, setShowResetPW] = useState(false);
  const [showResetPwConfirm, setShowResetPwConfirm] = useState(false);
  const [pwResetEmail, setPwResetEmail] = useState('');
  const [passwordInputType, setPasswordInputType] = useState('password');

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (user && freshLogin) {
      const continueTo = location?.state?.continueTo || '/';
      navigate(continueTo, { replace: true });
    } else if (user && !freshLogin) logout();
  }, [user, logout, freshLogin, navigate, location])

  useEffect(() => {
    setSubmitOk(email !== '' && password !== '');
  }, [email, password]);

  const submit = async (e) => {
    e.preventDefault();
    const err = await login({ email, password });
    if (err) {
      toast.error(`Error logging in: ${Api.error(err)}`);
    }
    setFreshLogin(true);
  }

  const sendPwReset = async email => {
    const [err,] = await Api.requestPwReset(email);
    if (err) {
      setShowResetPW(false);
      toast.error(`Error requesting password reset: ${Api.error(err)}`);
      console.error(err);
    } else {
      setPwResetEmail(email);
      setShowResetPW(false);
      setShowResetPwConfirm(true);
    }
  }

  return (
    <div className={className}>
      <div className='splash'>
        <img src={splashImg} alt='login splash' />
      </div>
      <div className={'form'} onSubmit={submit}>
        <div className='welcome'>{location?.state?.message ?? 'Please Login'}</div>
        <div className='auth'>
          <input autoFocus type='text' placeholder='email' value={email} onChange={e => setEmail(e.target.value)} />
          <span className='password'>
            <input type={passwordInputType} value={password} placeholder='password' onChange={e => setPassword(e.target.value)} />
            <FontAwesomeIcon className='eye' icon={passwordInputType === 'password' ? faEye : faEyeSlash} onClick={() => setPasswordInputType(prev => (prev === 'password' ? 'text' : 'password'))} />
          </span>
        </div>
        <button className='primary' disabled={!submitOk} onClick={submit}>Sign In</button>
        <button onClick={() => setShowResetPW(true)}>Forgot Password</button>
      </div>
      <PwResetModal isOpen={showResetPW} onConfirm={sendPwReset} onCancel={() => setShowResetPW(false)} />
      <PwResetConfirmModal isOpen={showResetPwConfirm} email={pwResetEmail} onConfirm={() => setShowResetPwConfirm(false)} />
    </div>
  )
})`${pageCss}`;

export default Login;
